import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { separateWords } from '@acme/auth'
import { Maybe } from '@acme/core'
import dayjs from 'dayjs'
import SP, { usePeriodo } from 'global/components/Selects/SelectPeriodo'
import ContentGuide from 'global/guides/ContentGuide'
import { useAuth } from 'hooks'
import { GitCompareArrowsIcon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { Alteracao, alteracoes_api } from 'service/api'

const columns: GridColDefPro[] = [
    {
        field: 'modulo',
        headerName: 'Objeto alterado',
        width: 200,
        valueGetter: ({ value }) =>
            Maybe.from(value).mapOrElse(
                value => separateWords(value),
                () => 'Não informado',
            ),
    },
    {
        field: 'Usuario',
        headerName: 'Usuário responsável',
        flex: 1,
        valueGetter: ({ value }) =>
            Maybe.from(value?.Supervisor?.nome).mapOrElse(
                nome => `${nome} (${value?.email})`,
                () => value?.email,
            ),
    },
    {
        field: 'createdAt',
        headerName: 'Data da alteração',
        width: 160,
        type: 'datetime-local',
        valueGetter: ({ value }) => dayjs(value).format('DD/MM/YYYY HH:mm'),
    },
    {
        field: 'motivo',
        headerName: 'Motivo da alteração (se existir)',
        flex: 0.8,
    },
    {
        ...optionsColumn,
        disableExport: false,
        field: 'diff',
        valueGetter: ({ value }) => JSON.stringify(value),
        renderCell: ({ id }) => (
            <IconButton href={`diff/${id}`} title="Ver diferenças">
                <GitCompareArrowsIcon />
            </IconButton>
        ),
    },
]

export default function Alteracoes() {
    const {
        decoded: { categoria, email },
    } = useAuth()
    const [[dataInicial, dataFinal], setPeriodo] = usePeriodo({
        type: 'periodo',
        defaultValue: [
            dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
            dayjs().add(1, 'day').format('YYYY-MM-DD'),
        ],
    })
    const { data = [], isLoading } = alteracoes_api.useFetch({
        queryParams: {
            dataInicial,
            dataFinal,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={[
                        'Histórico de alterações',
                        categoria != 3 ? email : '',
                    ]}
                >
                    <SP.Root
                        onChange={setPeriodo}
                        value={[dataInicial, dataFinal]}
                        allowedTypes={['periodo', 'competencia', 'data']}
                        variant="filled"
                        size="small"
                        width={320}
                    >
                        <SP.DateSelector />
                        <SP.Buttons />
                    </SP.Root>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    rows={data}
                    columns={columns}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'historico-alteracoes',
                        },
                    }}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useAlteracoesOutletContext() {
    return useOutletContext<{ data: Alteracao[] }>()
}
